import { render, staticRenderFns } from "./SHCheckCardSkeleton.vue?vue&type=template&id=34139e46&"
import script from "./SHCheckCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHCheckCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports